import { filter, mapTo } from 'rxjs/operators';
import {
  filterByLatest,
  mapToCtrlKeyIsDown,
  mapToDeleteKeyIsDown,
  mapToNumKey,
  mapToTargetAlphabetKeyIsDown,
  NumKey,
  useKeyEventAsStream,
  useStream
} from '../../imports/utils';

export const useKeyEventStreams = () => {
  const keyEvent$ = useKeyEventAsStream();

  const ctrlKeyIsDown$ = useStream(keyEvent$.pipe(mapToCtrlKeyIsDown()));

  const zKeyWithCtrl$ = useStream<void>(
    keyEvent$.pipe(
      mapToTargetAlphabetKeyIsDown('z'),
      filter(e => e),
      filterByLatest(ctrlKeyIsDown$),
      mapTo(undefined)
    )
  );

  const upperZKeyWithCtrl$ = useStream<void>(
    keyEvent$.pipe(
      mapToTargetAlphabetKeyIsDown('Z'),
      filter(e => e),
      filterByLatest(ctrlKeyIsDown$),
      mapTo(undefined)
    )
  );

  const numKey$ = useStream<NumKey>(keyEvent$.pipe(mapToNumKey()));

  const deleteKeyIsDown$ = useStream(keyEvent$.pipe(mapToDeleteKeyIsDown()));

  return {
    zKeyWithCtrl$,
    upperZKeyWithCtrl$,
    numKey$,
    deleteKeyIsDown$
  };
};
